import {
  IonItem,
  IonLabel,
  IonLoading,
  IonSelect,
  IonSelectOption,
} from "@ionic/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { TranslationsContext } from "../util/Translations";
import { PlannedListFilterType } from "../pages/MaterialIssue";
import { getDefaultFilterForIssueScreen } from "../api/UserSetups";
import {
  saveEamSetting,
  useSaveErrorToast,
} from "../pages/settings/settingsShared";
import {
  DEFAULT_FILTER_USER_PARAMETER,
  DEFAULT_FILTER_USER_SECTION,
} from "../util/Constants";

const DefaultFilterForIssueScreen: React.FC<{ disabled?: boolean }> = ({
  disabled,
}) => {
  const { translations } = useContext(TranslationsContext);
  const [defaultFilter, setDefaultFilter] = useState<PlannedListFilterType>(
    PlannedListFilterType.ItemsNotFullyIssued
  );
  const [showLoading, setShowLoading] = useState(false);
  const showSaveError = useSaveErrorToast();
  const savedFilter = useRef<PlannedListFilterType | undefined>();

  useEffect(() => {
    setShowLoading(true);
    getDefaultFilterForIssueScreen()
      .then((value) => {
        savedFilter.current = value;
        setDefaultFilter(value);
      })
      .finally(() => {
        setShowLoading(false);
      });
  }, []);

  const saveDefaultFilter = async (filterValue: PlannedListFilterType) => {
    if (filterValue === savedFilter.current) return;
    setDefaultFilter(filterValue);
    setShowLoading(true);
    const saved = await saveEamSetting(
      DEFAULT_FILTER_USER_SECTION,
      DEFAULT_FILTER_USER_PARAMETER,
      !filterValue ? PlannedListFilterType.ItemsNotFullyIssued : filterValue
    );
    setShowLoading(false);
    if (!saved) {
      setDefaultFilter(
        savedFilter.current ?? PlannedListFilterType.ItemsNotFullyIssued
      );
      showSaveError();
      return;
    }
    savedFilter.current = filterValue;
  };

  return (
    <>
      <IonLoading
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
        duration={5000}
      />
      <IonItem>
        <IonLabel position="stacked">
          {translations["lbl_mob_defaultfilter_issuescreen"] ||
            "Default Filter for Issue Screen"}
        </IonLabel>
        <IonSelect
          interface="popover"
          value={defaultFilter}
          disabled={disabled}
          onIonChange={(ev) => {
            saveDefaultFilter(ev.detail.value);
          }}
        >
          <IonSelectOption value={PlannedListFilterType.ItemsNotFullyIssued}>
            {PlannedListFilterType.ItemsNotFullyIssued}
          </IonSelectOption>
          <IonSelectOption value={PlannedListFilterType.All}>
            {PlannedListFilterType.All}
          </IonSelectOption>
          <IonSelectOption
            value={PlannedListFilterType.AvailableItemsNotFullyIssued}
          >
            {PlannedListFilterType.AvailableItemsNotFullyIssued}
          </IonSelectOption>
        </IonSelect>
      </IonItem>
    </>
  );
};

export default DefaultFilterForIssueScreen;
